/* eslint-disable max-len */
import React from 'react'
import { Link } from 'react-router-dom'
import { PriceHandler } from '../../../redux/helper/CamelCase'

const CreditStatus = (props) => {
    const {DISTRIBUTOR, orderData} = props
    return (
        <div className="bg-black px-5 lg:w-[25%] md:w-[47%] lg:mt-0 mt-5 w-full md:ml-5 ml-0 rounded-lg">
            <p className="text-white py-5 text-sm55 font-semibold">Credit Status</p>
            <div className="pt-4  pb-2.5">
                <div className="bg-[#FFFFFF] rounded px-3 py-2 xl:min-w-[206px] ">
                    <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Ador Cash</p>
                    <div className="flex justify-between">
                        <div className="flex items-center">
                            <Link to={'/list-of-transactions'}>
                                <a href="/list-of-transactions"><p className="xl:mr-2 mr-1 text-[#808285] font-semibold text-xs underline">View All Transactions </p> </a>
                            </Link>
                            <img src="/images/sort-red-left.svg" alt="img"/>
                        </div>
                        <p className="xl:text-lg md:text-lg lg:text-sm37 text-base font-bold text-[#090406] text-end">{PriceHandler(Number(DISTRIBUTOR.ADOR_CASH_BALANCE)-(orderData.length>1? orderData[1].freezed: 0))}</p>
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded px-3  my-5 py-2 xl:min-w-[206px] ">
                    <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Credit Limit</p>
                    <p className="xl:text-lg  md:text-lg lg:text-sm37 text-base font-bold text-[#090406] text-end">{PriceHandler(Number(DISTRIBUTOR.OVERALL_CREDIT_LIMIT))}</p>
                </div>
                <div className="bg-[#FFFFFF] rounded px-3 py-2 mb-5 xl:min-w-[206px] ">
                    <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Outstanding Amount</p>
                    <p className="xl:text-lg  md:text-lg lg:text-sm37 text-base font-bold text-[#090406] text-end">{PriceHandler(Number(DISTRIBUTOR.OUTSTANDING_AMT))}</p>
                </div>
                <div className="bg-[#FFFFFF] rounded px-3 py-2 mb-5 xl:min-w-[206px] ">
                    <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Credit Balance</p>
                    <p className="xl:text-lg  md:text-lg lg:text-sm37 text-base font-bold text-[#090406] text-end">{PriceHandler(Number(DISTRIBUTOR?.CREDIT_BALANCE))}</p>
                </div>
                <div className="bg-[#FFFFFF] rounded px-3 py-2 mb-5 xl:min-w-[206px] ">
                    <p className="text-sm font-semibold text-[#090406] pb-3 cash relative">Overdue Amount</p>
                    <p className="xl:text-lg  md:text-lg lg:text-sm37 text-base font-bold text-[#090406] text-end">{PriceHandler(Number(DISTRIBUTOR?.TOTAL_OVERDUE_AMT))}</p>
                </div>
            </div>
        </div>
    )
}

export default CreditStatus
